import styled from 'styled-components'
import DefaultButton from './DefaultButton'

const PanelButton = styled(DefaultButton)`
  display: flex;
  font-weight: bold;
  justify-content: center;
  text-align: center;
`

export default PanelButton
